/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DownOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Button, Dropdown, Space } from "antd";
import { LOCAL_STORAGE_KEY } from "../../constants/local";
import i18next from "i18next";


const LanguagePicker = () => {
  const { i18n } = useTranslation();
  const locale = i18n.language;
  const [language, setLanguage] = useState(locale);
  const items: MenuProps["items"] = [
    {
      label: <a style={{display:"flex", alignItems: "end", gap: "4px", fontSize: "16px"}} onClick={() => handleLanguageChange("fr")}>🇫🇷 Français</a>,
      key: "0",
    },
    {
      label: <a style={{display:"flex", alignItems: "end", gap: "4px", fontSize: "16px"}} onClick={() => handleLanguageChange("en")}>🇬🇧 English</a>,
      key: "1",
    },
  ];

  const handleLanguageChange = (lang: string) => {
    setLanguage(lang);
    i18next.changeLanguage(lang);
    localStorage.setItem(LOCAL_STORAGE_KEY.LANGUAGE, lang);
    window.location.reload();
  };

  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      <Button shape="round" size="small" onClick={(e) => e.preventDefault()}>
        <Space style={{display:"flex", alignItems: "center"}}>
          <div style={{fontSize:"24px"}}>{language === "en" ? <span>🇬🇧</span> : <span>🇫🇷</span>}</div>
          <DownOutlined style={{fontSize:"14px"}} />
        </Space>
      </Button>
    </Dropdown>
  );
};

export default LanguagePicker;
